"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultCacheOptions = void 0;
var DEFAULT_TTL = Number.MAX_VALUE;
var DEFAULT_CLEANUP_INTERVAL = 10000;
function getDefaultCacheOptions() {
    return {
        cacheMap: new Map(),
        cleanupInterval: DEFAULT_CLEANUP_INTERVAL,
        debug: false,
        displayName: '<fn>',
        cacheKeyFn: JSON.stringify,
        staleWhileRevalidate: false,
        statsFn: function () {
            /* no-op */
        },
        ttl: DEFAULT_TTL
    };
}
exports.getDefaultCacheOptions = getDefaultCacheOptions;
//# sourceMappingURL=defaults.js.map